import { pageInfo } from '@reolink-deps/reolink-web_multisite-utils';

const dateUbbREG =  /\[date(?:=(.*?))?](.*?)\[\/date]/g;

/**
 * 根据国家转换日期格式
 * [date]date[/date]
 * `eg. [date]2025-01-03[/date] => 1/3/2025`
 * @param text
 * @returns
 */
function handleDateText(text: string): string {

    if (!dateUbbREG.test(text)) {
        return text;
    }

    let lang = pageInfo.getLanguage();
    const country = pageInfo.getCountry();

    // 解决官网日本语言错误
    if (lang === 'jp') {
        lang = 'ja';
    }

    let locales: string;
    if (lang && country) {
        locales = `${lang}-${country.toLocaleUpperCase()}`;
    }

    // 其他地区转化成en-US
    if (country === '__') {
        locales = 'en-US';
    }

    return text.replace(dateUbbREG, (matchedTag, options, value) => {
        try {
            const date = new Date(value);
            const result = Intl.DateTimeFormat(locales).format(date);
            return `<span>${result}</span>`;
        }
        catch (e) {
            const errorMessages: string[] = ['Replace date text error'];
            errorMessages.push(`matchedTag: ${matchedTag}`);
            errorMessages.push(`options: ${options}`);
            console.error(errorMessages.join(', '), e);
        }
        return '';

    });
}

export default handleDateText;
